import React from 'react';
import { ControlledList, DataGridLayout } from 'framework/list';
import { TextField, useFieldHelper } from 'framework/ui/field';

const InvoiceReferencesList = ({ source }: { source: string }) => {
  const { getValue } = useFieldHelper({ source });
  const references = (getValue() as any) || {};

  return (
    <ControlledList data={{ items: references, totalPages: 1, totalElements: references.length }}>
      <DataGridLayout>
        <TextField source="referenceType" label="Type" width="50%" />
        <TextField source="referenceValue" label="Value" width="50%" />
      </DataGridLayout>
    </ControlledList>
  );
};

export default InvoiceReferencesList;
